const ListTypes = () =>
  import(/* webpackChunkName: "ValidDomain" */ 'src/components/Dashboard/Views/TaskTypes/TaskTypeList.vue');

const EditType = () =>
  import(/* webpackChunkName: "ValidDomain" */ 'src/components/Dashboard/Views/TaskTypes/TaskTypeEdit.vue');

export const taskTypeRoutes = [
  {
    path: 'task-types/',
    name: 'Task Types',
    component: ListTypes
  },
  {
    path: 'task-types/add',
    name: 'Add New Task Type',
    component: EditType
  },
  {
    path: 'task-types/edit/:id',
    name: 'Edit Task Type',
    component: EditType,
    props: route => ({ taskTypeId: parseInt(route.params.id)}),
  }
];

